import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";

function CleanCache({ domain, open, setOpen }) {
  const [loading, setLoading] = useState(false);

  const onClean = () => {
    setLoading(true);
    const snackArgsS = {
      item: t("domain.cache_cleaning"),
      op: t("global.done")
    };
    const snackArgsE = {
      item: t("domain.cache_cleaning"),
      op: ""
    };

    const formData = new FormData();
    formData.append("uid", domain.id);

    api.post(ApiUrls.domain.cleanCache, formData)
      .then((response) => {
        setLoading(false);
        setOpen("");

        if (response.data.status === "toofast") {
          showStatus("toofast");
        } else {
          let error = false;
          const res = response.data.result;
          for (let i = 0; i < res.length; i++) {
            if (res[i].report?.status === "Purge Error") {
              error = true;
              break;
            }
          }
          showStatus(
             error ? "error" : "success",
             error ? snackArgsE : snackArgsS
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        setOpen("");
        showStatus("error", snackArgsE);
      });
  }

  return (
     <Dialog
        open={true}
        onClose={() => setOpen("")}
     >
       <DialogContent>
         <DialogContentText id="alert-dialog-description">
           {t("message.confirm", { op: t("domain.cache_cleaning"), item: "", id: "" })}
         </DialogContentText>
       </DialogContent>

       <DialogActions>
         <Button onClick={() => setOpen("")} color="error" variant="contained">
           {t("global.cancel")}
         </Button>

         <LoadingButton
            color="success"
            loading={loading}
            variant="contained"
            onClick={onClean}
         >
           {t("global.confirm")}
         </LoadingButton>
       </DialogActions>
     </Dialog>
  )
}

export default CleanCache;
